import { ChakraFlex, ChakraText, FAIconName, Icon } from '@equip.health/ui';

import { MaiCitation } from './maiChat.types';
import { buildCitationLabel } from './maiChat.util';

interface MaiChatCitationPillProps {
  citation: MaiCitation;
}

const MaiChatCitationPill = ({ citation }: MaiChatCitationPillProps) => {
  const label = buildCitationLabel(citation);
  // http(s) only — never bind a javascript:/data: url into href.
  const hasLink = /^https?:\/\//i.test(citation.url);

  return (
    <ChakraFlex
      as={hasLink ? 'a' : undefined}
      href={hasLink ? citation.url : undefined}
      target={hasLink ? '_blank' : undefined}
      rel={hasLink ? 'noopener noreferrer' : undefined}
      aria-label={hasLink ? `Open source: ${label}` : undefined}
      data-testid="mai-chat-citation-pill"
      alignItems="center"
      gap="5px"
      padding="3px 9px"
      borderRadius="999px"
      background="neutral.background.secondary"
      border="1px solid"
      borderColor="neutral.line"
      cursor={hasLink ? 'pointer' : 'default'}
      textDecoration="none"
      _hover={hasLink ? { borderColor: 'primary.50' } : undefined}
    >
      <Icon
        name={FAIconName.fileLinesRegular}
        color="neutral.tertiary"
        size="sm"
      />
      <ChakraText color="neutral.secondary" fontSize="11px" fontWeight="500">
        {label}
      </ChakraText>
    </ChakraFlex>
  );
};

export default MaiChatCitationPill;
